import {
  useMemo,
} from 'react';
import {
  getDetailSections,
  getSummaryItems,
} from 'pages/Dashboard/pages/Billing/Payments/EOBDialog/Discrepancy/utils';
import {
  EOBExtractionResponseDTO,
} from 'dtos/eOBExtractionResponseDTO';

export default function useDiscrepancyData(
  parsedEOBErrors?: Omit<EOBExtractionResponseDTO, 'eobWithInsurancePayment'>,
) {
  const summaryItems = useMemo(() => getSummaryItems(parsedEOBErrors), [parsedEOBErrors]);
  const detailSections = useMemo(() => getDetailSections(parsedEOBErrors), [parsedEOBErrors]);
  const totalDiscrepancyCount = useMemo(() => (
    summaryItems.reduce((totalCount, item) => totalCount + item.count, 0)
  ), [summaryItems]);

  return {
    summaryItems,
    detailSections,
    totalDiscrepancyCount,
  };
}
